import store from '../store'

export default (to, from, next) => {
  if (!store.getters['auth/isAuthenticated'])
    return next({
      path: '/',
      query: { redirect: to.fullPath },
    })

  if (to.meta.isAdmin && !store.getters['auth/isAdmin']) {
    return next({
      path: '/',
      query: { redirect: to.fullPath },
    })
  }

  next()
}
